import { CobuText, CobuCard } from '@cobu/ui'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Strings } from '../../constants/Strings';

export default function SuggestGroupCard({ height, onPress }: { height: number; onPress: () => void }) {
  return (
    <CobuCard
      backgroundColor="$background"
      height={height}
      justifyContent="center"
      alignItems="center"
      onPress={onPress}
    >
      <CobuText variant='body'>{Strings.get().groups.suggest.cardCta}</CobuText>
      <AddCircleOutlineIcon width={24} height={24} />
    </CobuCard>
  )
}


